import type {
  ListMbcAdminGuidelinesResponse,
  MbcAdminGuideline,
  MbcAdminGuidelineBody,
  MbcAdminGuidelineResponse,
} from "@nlc/shared-types";

import { adminRequest } from "../adminRequest";

export async function listGuidelines(): Promise<MbcAdminGuideline[]> {
  const { guidelines } =
    await adminRequest<ListMbcAdminGuidelinesResponse>("/guidelines");

  return guidelines;
}

export async function saveGuideline({
  fields,
  guidelineId,
}: {
  fields: MbcAdminGuidelineBody;
  guidelineId: null | string;
}): Promise<MbcAdminGuideline> {
  const response = await adminRequest<MbcAdminGuidelineResponse>(
    guidelineId
      ? `/guidelines/${encodeURIComponent(guidelineId)}`
      : "/guidelines",
    guidelineId ? "PUT" : "POST",
    fields,
  );

  return response.guideline;
}

export async function deleteGuideline(guidelineId: string): Promise<void> {
  await adminRequest(
    `/guidelines/${encodeURIComponent(guidelineId)}`,
    "DELETE",
  );
}
